import(/* webpackMode: "eager", webpackExports: ["BlogsPage"] */ "/home/buyme/htdocs/buyme.lk/src/components/BlogsPage.tsx");
